import React, { useState, useEffect } from 'react';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const MyPayslips = () => {
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPayslips();
  }, []);

  const fetchPayslips = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('employeeToken');
      const res = await fetch('/api/employee/payslips', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const result = await res.json();
      if (result.success) {
        setPayslips(result.data || []);
      } else {
        setError(result.error || 'Failed to fetch payslips');
      }
    } catch (err) {
      setError(err.message || 'Error loading payslips');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header Bar */}
      <div className="bg-card border border-border rounded-xl p-5 shadow-sm">
        <h2 className="text-lg font-bold text-foreground">My Payslips</h2>
        <p className="text-xs text-muted-foreground">Download official monthly payroll statements and salary slips</p>
      </div>

      {loading ? (
        <div className="bg-card border border-border rounded-xl p-12 text-center shadow-sm">
          <Icon name="Loader2" size={28} className="animate-spin text-teal-600 mx-auto mb-2" />
          <p className="text-xs text-muted-foreground">Loading payslip records...</p>
        </div>
      ) : error ? (
        <div className="bg-card border border-border rounded-xl p-8 text-center text-rose-500 font-semibold shadow-sm">
          {error}
        </div>
      ) : payslips.length === 0 ? (
        <div className="bg-card border border-border rounded-xl p-16 text-center text-muted-foreground shadow-sm">
          <Icon name="FileText" size={40} className="mx-auto mb-3 opacity-40 text-teal-600" />
          <h3 className="text-base font-bold text-foreground mb-1">No Payslips Available Yet</h3>
          <p className="text-xs max-w-sm mx-auto text-muted-foreground">
            Official monthly payslips will appear here once payroll processing is finalized by the HR & Payroll department.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {payslips.map((ps) => (
            <div key={ps.id} className="bg-card border border-border rounded-xl p-5 shadow-sm space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold text-primary bg-primary/10 px-2.5 py-1 rounded-md">
                  {ps.payroll_period || 'Payroll Statement'}
                </span>
                <span className="text-xs text-muted-foreground font-mono">#{ps.id.substring(0, 8)}</span>
              </div>

              <div>
                <p className="text-xs text-muted-foreground">Net Pay Amount</p>
                <p className="text-2xl font-bold text-foreground">₹{Number(ps.net_salary || ps.net_pay || 0).toLocaleString('en-IN')}</p>
              </div>

              <div className="pt-3 border-t border-border flex items-center justify-between text-xs">
                <span className="text-muted-foreground">Status: <span className="font-semibold text-emerald-600">Disbursed</span></span>
                <Button
                  size="sm"
                  variant="outline"
                  iconName="Download"
                  iconPosition="left"
                  onClick={() => alert(`Downloading Payslip PDF for ${ps.payroll_period || 'Statement'}`)}
                >
                  Download PDF
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyPayslips;
